module.exports = __webpack_public_path__ + "img/854eed0.png";